import React from "react";
import SEO from "../components/SEO";
import HeroInner from "../components/HeroInner/HeroInner";
import Services from "../components/Services";
import ChatBot from "../components/ChatBot";
import GlobalScripts from "../components/GlobalScripts";
import Menu from "../components/Menu/Menu";
import Footer from "../components/Footer";
import "./DesarrolloWeb.css";

function DesarrolloWeb() {
  return (
    <>
      <SEO
        title="Desarrollo Web | React, Next.js y soluciones modernas"
        description="Sitios rápidos, escalables y optimizados con tecnologías modernas."
        url="https://juancarlosmancharamos.ar/desarrollo-web"
      />

      <Menu />

      <HeroInner
        title="Desarrollo Web"
        subtitle="Sitios rápidos y responsivos con React, Next.js y tecnologías modernas"
        bg="/assets/images/bg-dev.jpg"
      />

	<section
	  className="container dev-section"
	  style={{
		padding: "80px 20px",
		color: "#fff",
		textAlign: "center"
	  }}
	>
	  <h2>Desarrollo Web Profesional en React y Next.js</h2>

	  <p>
		Desarrollo sitios web modernos, rápidos y optimizados utilizando tecnologías
		como React, Next.js y JavaScript avanzado. Creo soluciones digitales a medida
		enfocadas en rendimiento, experiencia de usuario y posicionamiento SEO.
	  </p>

	  <p>
		Cada proyecto está pensado para cargar en milisegundos, adaptarse a todos los
		dispositivos y generar resultados reales: más tráfico, más consultas y más
		conversiones. Trabajo tanto con aplicaciones web complejas como con sitios
		corporativos y landing pages optimizadas.
	  </p>

	  <h3>¿Qué incluye mi servicio de desarrollo web?</h3>

	  <p>
		Desarrollo frontend con React, arquitectura escalable con Next.js,
		optimización de velocidad (Core Web Vitals), integración con APIs,
		automatizaciones y soluciones personalizadas para cada negocio.
	  </p>

	  <p>
		También puedo integrar tu sitio con CMS como WordPress, WooCommerce o
		PrestaShop, permitiéndote gestionar contenidos o productos de forma simple
		sin perder rendimiento.
	  </p>

	  <h3>Optimización SEO y rendimiento</h3>

	  <p>
		Todos los sitios están preparados para posicionar en Google desde el inicio:
		estructura semántica, metadatos optimizados, carga rápida y buenas prácticas
		técnicas que mejoran la visibilidad orgánica.
	  </p>

	  <h3>Desarrollo a medida para tu negocio</h3>

	  <p>
		No utilizo plantillas genéricas. Cada desarrollo es único y pensado según tus
		objetivos: generar leads, vender online o potenciar tu marca digital.
	  </p>
	</section>
	  <section id="abt-lnk" className="center-first">
		<div className="gp no-tpgp btm-spc130">
		  <div className="container">
			<div className="skls-wrp2 ovrlp-60 text-center">
			  <div className="skls-inr">
				<h2 itemProp="headline">
				  + servicios
				</h2>
			  </div>
			  <Services />
			</div>
		  </div>
		</div>
	  </section>
	  <Footer />
	  <ChatBot />
      <GlobalScripts />
    </>
  );
}

export default DesarrolloWeb;